export var SHOPIFY_LEAD_UPGRADED_PLAN = 'SHOPIFY_LEAD_UPGRADED_PLAN';
